import { memo } from 'react';
import {
    ICON_MATCH_EVENT,
    IEvent,
    IPlayer,
    MATCH_EVENT,
} from '@zmedia/bm-soccer-ui/interface';
import { ArrayUtils } from '@zmedia/bm-soccer-ui/utils';
import {
    Element,
    Icon,
    Level,
    List,
    RouterLink,
} from '@zmedia/bm-soccer-ui/components';
import { URL_SOCCER_PAGE } from '@zmedia/bm-soccer-ui/modules/shared';
import { Avatar } from '@zmedia/bm-soccer-ui/modules/shared/components/avatar';
import { EventPlayer } from '../event';
import styles from './style.module.scss';

export function SubstitutionList({ players = [] }: { players: IPlayer[] }) {
    if (ArrayUtils.isEmpty(players)) {
        return null;
    }

    return (
        <List className={styles['column-list']}>
            {players.map((player: any, index: number) => {
                const eventSubstitution: IEvent[] = player.events.filter(
                    (event: IEvent) =>
                        event.type.id === MATCH_EVENT.SUBSTITUTION
                );
                const otherEvent: IEvent[] = player.events.filter(
                    (event: IEvent) => {
                        return event.type.id !== MATCH_EVENT.SUBSTITUTION;
                    }
                );

                return (
                    <List.Item key={index}>
                        <Level>
                            <Level.Side align="left">
                                <RouterLink
                                    to={`${URL_SOCCER_PAGE.SUBPATH}${player.path}`}
                                    title={player.name}
                                >
                                    <Avatar
                                        avatar={player.avatar}
                                        name={player.name}
                                    >
                                        <Icon icon="sub-in" />

                                        <EventPlayer events={otherEvent} />
                                    </Avatar>
                                    <Element className={styles['player-info']}>
                                        {player.shirtNumber > 0 && (
                                            <Element
                                                className={styles['shirt']}
                                            >
                                                {player.shirtNumber
                                                    .toString()
                                                    .padStart(2, '0')}
                                            </Element>
                                        )}
                                        <Element className={styles['name']}>
                                            {player.shortName}
                                        </Element>
                                    </Element>
                                </RouterLink>
                            </Level.Side>
                            <Level.Side align="right">
                                <Element className={styles['bagdes-container']}>
                                    {otherEvent?.map((event) => (
                                        <Icon
                                            icon={
                                                ICON_MATCH_EVENT[
                                                    MATCH_EVENT[event.type.id]
                                                ]
                                            }
                                            key={event.minuteLabel}
                                        />
                                    ))}
                                </Element>
                                <Element className={styles['sub-text']}>
                                    {eventSubstitution[0].minuteLabel}
                                </Element>

                                <Icon icon="sub-in" />
                            </Level.Side>
                        </Level>
                    </List.Item>
                );
            })}
        </List>
    );
}
export default memo(SubstitutionList);
